module.exports = {
	"$schema": "http://json-schema.org/draft-04/schema#",
	"type": "object",
	"properties": {
		"target": {
			"oneOf": [
				{
					"type": "object",
					"properties": {
						"table": {
							"type": "string"
						},
						"column": {
							"type": "string"
						}
					},
					"required": [
						"table",
						"column"
					]
				},
				{
					"type": "object",
					"properties": {
						"table": {
							"type": "string"
						},
						"hierarchy": {
							"type": "string"
						},
						"hierarchyLevel": {
							"type": "string"
						}
					},
					"required": [
						"table",
						"hierarchy",
						"hierarchyLevel"
					]
				},
				{
					"type": "object",
					"properties": {
						"table": {
							"type": "string"
						},
						"measure": {
							"type": "string"
						}
					},
					"required": [
						"table",
						"measure"
					]
				}
			]
		},
		"logicalOperator": {
			"type": "string"
		},
		"conditions": {
			"type": "array",
			"items": {
				"type": "object",
				"properties": {
					"value": {
						"type": [
							"string",
							"boolean",
							"number"
						]
					},
					"operator": {
						"type": "string"
					}
				},
				"required": [
					"value",
					"operator"
				]
			}
		}
	},
	"required": [
		"target",
		"logicalOperator",
		"conditions"
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/schemas/advancedFilter.json
 ** module id = 1
 ** module chunks = 0
 **/